const RUN_STATE_STATUS = {
  waiting_for_user: 'waiting_user',
  waiting_user: 'waiting_user',
  completed: 'completed',
  partial: 'partial',
  degraded: 'degraded',
  failed: 'failed',
  cancelled: 'cancelled',
  canceled: 'cancelled',
  running: 'running',
  queued: 'running',
};

function firstTruthy(...values) {
  return values.find(Boolean);
}

export function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

export function text(value) {
  return String(value ?? '').trim();
}

export function number(value, fallback = 0) {
  const resolved = Number(value);
  return Number.isFinite(resolved) ? resolved : fallback;
}

export function workflowProjection(item = {}) {
  return resolveObject(firstTruthy(item.workflowProjection, item.workflow_projection));
}

// A present empty projection is authoritative; absence alone permits legacy readers.
export const workflowProgressProjection = (item) => {
  const value = workflowProjection(item).progress_projection;
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
};

export const workflowRunState = (item) => {
  const projection = workflowProjection(item);
  return normalizeRunState(firstTruthy(
    workflowProgressProjection(item)?.status,
    projection.run_state, projection.runState, projection.status,
  ));
};

export const hasAuthoritativeWorkflowState = (item) => (
  workflowProgressProjection(item) !== null || Boolean(workflowRunState(item))
);

function normalizeRunEvent(record = {}, fallbackSequence = 0) {
  const source = resolveObject(record);
  const payload = resolveObject(source.payload);
  const eventName = text(firstTruthy(source.event_name, source.eventName, payload.event_name));
  if (!eventName) {
    return null;
  }
  return {
    event_name: eventName,
    payload,
    sequence: number(firstTruthy(source.sequence, payload.run_event_sequence), fallbackSequence),
  };
}

export function workflowRunEvents(item = {}) {
  return resolveArray(workflowProjection(item).run_events)
    .map((event, index) => normalizeRunEvent(event, index + 1))
    .filter(Boolean)
    .sort((left, right) => left.sequence - right.sequence);
}

export function normalizeRunState(value = '') {
  const state = text(value);
  return firstTruthy(RUN_STATE_STATUS[state], state) ?? '';
}

function normalizeRunStep(step = {}) {
  const source = resolveObject(step);
  const stepId = text(firstTruthy(source.step_id, source.stepId));
  if (!stepId) {
    return null;
  }
  return {
    ...source,
    step_id: stepId,
    status: normalizeRunState(source.status),
    capability_id: text(firstTruthy(source.capability_id, source.capabilityId)),
    owner_capability: text(firstTruthy(source.owner_capability, source.ownerCapability)),
    reason: text(source.reason),
    sequence: number(source.sequence),
  };
}

export function workflowRunSteps(item = {}) {
  const projection = workflowProjection(item);
  return resolveArray(firstTruthy(projection.run_steps, projection.runSteps))
    .map(normalizeRunStep)
    .filter(Boolean)
    .sort((left, right) => left.sequence - right.sequence);
}
